import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { VersionComparisonV3Detail } from '@/types/automations.ts';
import { get_automation_version_comparison_v3_detail_url } from '@/utils/urls.ts';

export default function useRetrieveVersionComparisonV3Detail(base?: string, target?: string, ref?: string, enabled = true, fingerprint?: string) {
  const apiClient = useApiClient();
  return useQuery<VersionComparisonV3Detail, Error>({
    queryKey: ['automation-version-comparison-v3-detail', base, target, ref, fingerprint],
    staleTime: 0,
    queryFn: async () => (await apiClient.get(get_automation_version_comparison_v3_detail_url(target, ref), { params: { base_version_id: base } })).data,
    enabled: enabled && !!base && !!target && !!ref,
  });
}
